const Logo = ({ variant = "blue", className = "h-6", testId = "miles-logo" }) => (
  <img
    src={variant === "white" ? "/brand/logo-white.webp" : "/brand/logo-blue.webp"}
    alt="MILES"
    data-testid={testId}
    className={`w-auto select-none ${className}`}
    draggable="false"
  />
);

export default Logo;
